class MenberModal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const memberModal = () => {
      //TOP トリガー
      const memberCards = document.querySelectorAll(".js-member-hov")
      //メガメニュー
      const memberMageMenu = document.querySelectorAll(".js-mega-modal-trigger")
      //ハンバーガーメニュー
      const memberHamMenu = document.querySelectorAll(".js-ham-trigger")
      //フッターメニュー
      const memberFooterMenu = document.querySelectorAll(".js-footer-trigger")

      const modal = document.querySelector(".top-modal");
      const modalItem = document.querySelector(".top-modal__item")
      const modalClose = document.querySelector(".top-modal__close")
      const modalOverlay = document.querySelector(".top-modal__overlay")
      const path =  modalItem.getAttribute('src');


      const triggerElements = [
        memberCards,
        memberMageMenu,
        memberHamMenu,
        memberFooterMenu
      ]

      triggerElements.forEach(ele => {

        ele.forEach((card, i) => {
          card.addEventListener("click", () => {
            modal.classList.add("is-active")

            console.log(path);
            modalItem.setAttribute('src', `${path}/member-0${i + 1}.mp4`);
          })
        })

      })


      modalClose.addEventListener("click", () => {
        modal.classList.remove("is-active")
        modalItem.pause();
      })
      modalOverlay.addEventListener("click", () => {
        modal.classList.remove("is-active")
        modalItem.pause();
      })
    }

    const noLoad = () => {
      const noEventAll = document.querySelectorAll(".no-event")
      noEventAll.forEach(noEvent => {
        noEvent.addEventListener("click", function (event) {
          event.preventDefault();
        });
      })
    }


    memberModal();
    noLoad();

  }
}
